import React, { FC } from 'react';

const DOTS = [
  { cx: 19.2, cy: 12, r: 2.7 },
  { cx: 17.1, cy: 17.1, r: 2.7 },
  { cx: 12, cy: 19.2, r: 2.7 },
  { cx: 6.9, cy: 17.1, r: 2.7 },
  { cx: 4.8, cy: 12, r: 2.7 },
  { cx: 6.9, cy: 6.9, r: 2.7 },
  { cx: 12, cy: 4.8, r: 2.7 },
  { cx: 17.1, cy: 6.9, r: 1.9 },
];

const OrbitMark: FC = () => (
  <svg
    className="orbit-mark"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    {DOTS.map((d, i) => (
      <circle key={i} cx={d.cx} cy={d.cy} r={d.r} fill="#333" />
    ))}
  </svg>
);

export default OrbitMark;
